import {
    FormatAlignCenterRounded,
    FormatAlignJustifyRounded,
    FormatAlignLeftRounded,
    FormatAlignRightRounded,
} from '@mui/icons-material';
import BlockButton from './BlockButton';
import { useTranslation } from 'react-i18next';

function AlignButtons() {
    const { t } = useTranslation();

    return (
        <span dir="ltr">
            <BlockButton
                path="attributes.style.textAlign"
                value="left"
                icon={<FormatAlignLeftRounded fontSize="small" />}
                tooltip={t('Align Left')}
                fallbackProperty="text-align"
            />
            <BlockButton
                path="attributes.style.textAlign"
                value="center"
                icon={<FormatAlignCenterRounded fontSize="small" />}
                tooltip={t('Align Center')}
                fallbackProperty="text-align"
            />
            <BlockButton
                path="attributes.style.textAlign"
                value="right"
                icon={<FormatAlignRightRounded fontSize="small" />}
                tooltip={t('Align Right')}
                fallbackProperty="text-align"
            />
            <BlockButton
                path="attributes.style.textAlign"
                value="justify"
                icon={<FormatAlignJustifyRounded fontSize="small" />}
                tooltip={t('Justify')}
                fallbackProperty="text-align"
            />
        </span>
    );
}

export default AlignButtons;
